/**
 * Romy flower icon — Phosphor-style, stroke-based, matches the nav icon weight system.
 * Use weight="regular" (default) for nav/inline, weight="fill" for larger decorative uses.
 */
export default function RomyIcon({
  size = 24,
  color,
  weight = 'regular',
}: {
  size?: number;
  color?: string;
  weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill';
}) {
  const c = color || 'currentColor';
  const sw =
    weight === 'thin' ? 8 : weight === 'light' ? 12 : weight === 'bold' ? 24 : 16;

  // Star points at center (128, 96) — shifted +12 to vertically center flower in circle
  const star =
    'M128 64 L142 82 L164 96 L142 110 L128 128 L114 110 L92 96 L114 82 Z';

  if (weight === 'fill') {
    return (
      <svg width={size} height={size} viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="128" cy="128" r="120" stroke={c} strokeWidth="16" fill="none" />
        <circle cx="128" cy="96" r="44" stroke={c} strokeWidth="16" fill="none" />
        <path d={star} fill={c} />
        <rect x="120" y="140" width="16" height="88" rx="8" fill={c} />
        <path d="M128 196 C112 192, 80 180, 64 156" stroke={c} strokeWidth="16" fill="none" strokeLinecap="round" />
        <path d="M128 196 C144 192, 176 180, 192 156" stroke={c} strokeWidth="16" fill="none" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="128" cy="128" r="120" stroke={c} strokeWidth={sw} fill="none" />
      <circle cx="128" cy="96" r="44" stroke={c} strokeWidth={sw} fill="none" />
      <path d={star} stroke={c} strokeWidth={sw} strokeLinejoin="round" fill="none" />
      <line x1="128" y1="140" x2="128" y2="228" stroke={c} strokeWidth={sw} strokeLinecap="round" />
      <path d="M128 196 C112 192, 80 180, 64 156" stroke={c} strokeWidth={sw} fill="none" strokeLinecap="round" />
      <path d="M128 196 C144 192, 176 180, 192 156" stroke={c} strokeWidth={sw} fill="none" strokeLinecap="round" />
    </svg>
  );
}
